import { render, staticRenderFns } from "./BarcodeItemsEditor.vue?vue&type=template&id=275ee087&scoped=true&"
import script from "./BarcodeItemsEditor.vue?vue&type=script&lang=ts&"
export * from "./BarcodeItemsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeItemsEditor.vue?vue&type=style&index=0&id=275ee087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ee087",
  null
  
)

export default component.exports